import React, { useEffect, useRef, useState } from "react";
import BgHeader from "../BgHeader";
import OverviewStepList from "./OverviewStepList";

function InvestmentCalculator() {
  return (
    <>
      <div className=" w-full bg-[#F7F7F7]" id="InvestmentCalculator">
        <BgHeader title="Investment Calculator" invst={true} />
        <OverviewStepList />
      </div>
    </>
  );
}

export default InvestmentCalculator;
